import { baseStoreCreator } from '@/utils/store';

export interface QRCodeState {
  qrCodeId?: string;
  documentId?: string;
}

export const DEFAULT_VALUES: QRCodeState = {
  qrCodeId: '',
  documentId: '',
};

export const useQRCodeStore = baseStoreCreator<QRCodeState>(
  DEFAULT_VALUES,
);

export default useQRCodeStore;
